import clsx from "clsx";
import React from "react";
import { INPUT_LABEL_CLS } from "../BaseInput";

interface PAdornmentWrapper extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

export const AdornmentWrapper: React.FC<PAdornmentWrapper> = ({
  children,
  className,
  ...props
}) => (
  <div
    className={clsx("flex flex-col justify-center", INPUT_LABEL_CLS, className)}
    {...props}
  >
    {children}
  </div>
);
